// Billing — Owner only. Plan, seats, invoices.

import { useAuth } from '../contexts/AuthContext';

export function BillingPage() {
  const { user } = useAuth();

  if (!user) return null;

  return (
    <>
      <div className="page-header">
        <div>
          <h1 className="page-title">Billing</h1>
          <p className="page-subtitle">{user.orgName} · plan and invoices</p>
        </div>
      </div>

      <div style={{ maxWidth: '600px', display: 'flex', flexDirection: 'column', gap: 'var(--space-6)' }}>
        <div className="card">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 'var(--space-4)' }}>
            <div>
              <h2 style={{ fontSize: '1rem', marginBottom: 'var(--space-2)' }}>Current plan</h2>
              <p style={{ fontSize: '1.5rem', fontWeight: 700 }}>Starter</p>
              <p style={{ fontSize: '0.875rem', color: 'var(--color-text-muted)', marginTop: 'var(--space-1)' }}>
                Up to 50 members · $8/seat/mo
              </p>
            </div>
            <button className="btn btn--secondary">Upgrade plan</button>
          </div>
        </div>

        <div className="card">
          <h2 style={{ fontSize: '1rem', marginBottom: 'var(--space-4)' }}>Seat usage</h2>
          <div style={{ display: 'flex', gap: 'var(--space-8)', flexWrap: 'wrap' }}>
            <div>
              <p style={{ fontSize: '2rem', fontWeight: 700 }}>—</p>
              <p style={{ fontSize: '0.8125rem', color: 'var(--color-text-muted)' }}>Active seats</p>
            </div>
            <div>
              <p style={{ fontSize: '2rem', fontWeight: 700 }}>50</p>
              <p style={{ fontSize: '0.8125rem', color: 'var(--color-text-muted)' }}>Included seats</p>
            </div>
          </div>
        </div>

        <div className="card">
          <h2 style={{ fontSize: '1rem', marginBottom: 'var(--space-4)' }}>Invoices</h2>
          <div className="empty-state" style={{ padding: 'var(--space-8) 0' }}>
            <p className="empty-state__body">
              Billing integration is coming in Stage 3. Invoices will appear here.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
